export default __webpack_public_path__ + "b6361313704bb185125c8f382ae6797f.coffee";